<button
  *ngIf="discussion.voted !== null"
  type="button"
  class="btn btn-sm"
  [ngClass]="{
    disabled: isSubmitting,
    'btn-outline-primary': !discussion.voted.upVote,
    'btn-primary': discussion.voted.upVote
  }"
  (click)="toggleUpvote()"
  placement="right"
  ngbTooltip="Vote discussion as meaningful"
>
  <div style="display: inline-block">
    <i class="icofont icofont-circled-up"> </i>
    <span>{{ discussion.upVoteCount }} </span>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</button>

<button
  *ngIf="discussion.voted === null"
  type="button"
  class="btn btn-sm btn-outline-primary"
  [ngClass]="{ disabled: isSubmitting }"
  (click)="toggleUpvote()"
  placement="right"
  ngbTooltip="Vote discussion as meaningful"
>
  <div style="display: inline-block">
    <i class="icofont icofont-circled-up"> </i>
    <span>{{ discussion.upVoteCount }} </span>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</button>
